"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReferenceTableCell = exports.CausalityTableCell = exports.DeadlineTableCell = exports.BestRiskTableCell = exports.WorstRiskTableCell = exports.LinksTableCell = exports.BimLocationsTableCell = exports.EvaluationTableCell = exports.OwnerTableCell = exports.MeasurementTableCell = exports.SelectionsCell = exports.CheckboxesTableCell = exports.NumberTableCell = exports.HyperLinkTableCell = exports.FileContentCell = exports.TableCellDataFile = exports.ScoreTableCell = exports.InactivityTableCell = exports.TableCellDataInactivity = exports.BooleanTableCell = exports.TextTableCell = exports.TableCell = exports.TableCellDataReferences = exports.TableCellDataCausality = exports.TableCellDataDeadline = exports.TableCellDataMeasurement = exports.TableCellDataEvaluation = exports.TableCellDataBestRisk = exports.TableCellDataWorstRisk = exports.TableCellDataOwner = exports.TableCellDataLinks = exports.TableCellDataChoices = exports.TableCellData = void 0;
var React = require("react");
var riskvalue_1 = require("./riskvalue");
var deadline_1 = require("./deadline");
var lists_1 = require("../lib/lists");
var causality_1 = require("../riskPage/causality");
var utils_1 = require("../../utils");
var referenceList_1 = require("../references/referenceList");
var buttons_1 = require("../buttons");
var TableCellData = (function () {
    function TableCellData() {
    }
    return TableCellData;
}());
exports.TableCellData = TableCellData;
var TableCellDataChoices = (function (_super) {
    __extends(TableCellDataChoices, _super);
    function TableCellDataChoices(selected, useRadioButtons, addNoSelectionOption) {
        var _this = _super.call(this) || this;
        _this.original = selected || [];
        _this.selected = selected.length ? selected.slice() : [];
        _this.useRadioButtons = !!useRadioButtons;
        _this.addNoSelectionOption = !!addNoSelectionOption;
        return _this;
    }
    return TableCellDataChoices;
}(TableCellData));
exports.TableCellDataChoices = TableCellDataChoices;
var TableCellDataLinks = (function (_super) {
    __extends(TableCellDataLinks, _super);
    function TableCellDataLinks(links, show_titles) {
        var _this = _super.call(this) || this;
        _this.links = links;
        _this.show_titles = show_titles;
        return _this;
    }
    return TableCellDataLinks;
}(TableCellData));
exports.TableCellDataLinks = TableCellDataLinks;
var TableCellDataOwner = (function (_super) {
    __extends(TableCellDataOwner, _super);
    function TableCellDataOwner(user_id) {
        var _this = _super.call(this) || this;
        _this.user_id = user_id;
        return _this;
    }
    return TableCellDataOwner;
}(TableCellData));
exports.TableCellDataOwner = TableCellDataOwner;
var TableCellDataWorstRisk = (function (_super) {
    __extends(TableCellDataWorstRisk, _super);
    function TableCellDataWorstRisk(critical, worst_risk_color, worst_risk_value, is_opportunity, show_explicit_value) {
        var _this = _super.call(this) || this;
        _this.critical = critical;
        _this.worst_risk_color = worst_risk_color;
        _this.worst_risk_value = worst_risk_value;
        _this.is_opportunity = is_opportunity;
        _this.show_explicit_value = show_explicit_value;
        return _this;
    }
    return TableCellDataWorstRisk;
}(TableCellData));
exports.TableCellDataWorstRisk = TableCellDataWorstRisk;
var TableCellDataBestRisk = (function (_super) {
    __extends(TableCellDataBestRisk, _super);
    function TableCellDataBestRisk(critical, best_risk_color, best_risk_value, is_opportunity, show_explicit_value) {
        var _this = _super.call(this) || this;
        _this.critical = critical;
        _this.best_risk_color = best_risk_color;
        _this.best_risk_value = best_risk_value;
        _this.is_opportunity = is_opportunity;
        _this.show_explicit_value = show_explicit_value;
        return _this;
    }
    return TableCellDataBestRisk;
}(TableCellData));
exports.TableCellDataBestRisk = TableCellDataBestRisk;
var TableCellDataEvaluation = (function (_super) {
    __extends(TableCellDataEvaluation, _super);
    function TableCellDataEvaluation(critical, color, value, is_opportunity, matrix_id, risk_id, evaluation_type, show_explicit_value) {
        var _this = _super.call(this) || this;
        _this.critical = critical;
        _this.color = color;
        _this.value = value;
        _this.is_opportunity = is_opportunity;
        _this.show_explicit_value = show_explicit_value;
        _this.matrix_id = matrix_id;
        _this.risk_id = risk_id;
        _this.evaluation_type = evaluation_type;
        return _this;
    }
    return TableCellDataEvaluation;
}(TableCellData));
exports.TableCellDataEvaluation = TableCellDataEvaluation;
var TableCellDataMeasurement = (function (_super) {
    __extends(TableCellDataMeasurement, _super);
    function TableCellDataMeasurement(value, unit) {
        var _this = _super.call(this) || this;
        _this.value = value;
        _this.unit = unit;
        return _this;
    }
    return TableCellDataMeasurement;
}(TableCellData));
exports.TableCellDataMeasurement = TableCellDataMeasurement;
var TableCellDataDeadline = (function (_super) {
    __extends(TableCellDataDeadline, _super);
    function TableCellDataDeadline(urgency) {
        var _this = _super.call(this) || this;
        _this.urgency = urgency;
        return _this;
    }
    return TableCellDataDeadline;
}(TableCellData));
exports.TableCellDataDeadline = TableCellDataDeadline;
var TableCellDataCausality = (function (_super) {
    __extends(TableCellDataCausality, _super);
    function TableCellDataCausality(causalities, isCause, show_statuses) {
        var _this = _super.call(this) || this;
        _this.causalities = causalities;
        _this.isCause = isCause;
        _this.show_statuses = show_statuses;
        return _this;
    }
    return TableCellDataCausality;
}(TableCellData));
exports.TableCellDataCausality = TableCellDataCausality;
var TableCellDataReferences = (function (_super) {
    __extends(TableCellDataReferences, _super);
    function TableCellDataReferences(references, originType) {
        var _this = _super.call(this) || this;
        _this.references = references;
        _this.originType = originType;
        return _this;
    }
    return TableCellDataReferences;
}(TableCellData));
exports.TableCellDataReferences = TableCellDataReferences;
var TableCell = (function () {
    function TableCell(id, data, display, fieldName, user_field_id) {
        this.id = id;
        this.data = data;
        this.display = display;
        this.fieldName = fieldName;
        this.user_field_id = user_field_id;
    }
    TableCell.prototype.get_display = function () {
        return React.createElement(React.Fragment, null, this.display || '');
    };
    return TableCell;
}());
exports.TableCell = TableCell;
var TextTableCell = (function (_super) {
    __extends(TextTableCell, _super);
    function TextTableCell() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return TextTableCell;
}(TableCell));
exports.TextTableCell = TextTableCell;
var BooleanTableCell = (function (_super) {
    __extends(BooleanTableCell, _super);
    function BooleanTableCell() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BooleanTableCell.prototype.get_display = function () {
        return (React.createElement("div", { className: "custom-control custom-switch" },
            React.createElement("input", { type: "checkbox", checked: this.data, className: "custom-control-input" }),
            React.createElement("label", { className: "custom-control-label" })));
    };
    return BooleanTableCell;
}(TableCell));
exports.BooleanTableCell = BooleanTableCell;
var TableCellDataInactivity = (function (_super) {
    __extends(TableCellDataInactivity, _super);
    function TableCellDataInactivity(inactive, inactive_days) {
        var _this = _super.call(this) || this;
        _this.inactive = inactive;
        _this.inactive_days = inactive_days;
        return _this;
    }
    return TableCellDataInactivity;
}(TableCellData));
exports.TableCellDataInactivity = TableCellDataInactivity;
var InactivityTableCell = (function (_super) {
    __extends(InactivityTableCell, _super);
    function InactivityTableCell() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InactivityTableCell.prototype.get_display = function () {
        return (this.data.inactive ?
            React.createElement("span", null,
                React.createElement("i", { className: "text-danger fas fa-fw fa-circle" }))
            : React.createElement("span", null,
                React.createElement("i", { className: "text-success-bright fas fa-fw fa-circle" })));
    };
    return InactivityTableCell;
}(TableCell));
exports.InactivityTableCell = InactivityTableCell;
var ScoreTableCell = (function (_super) {
    __extends(ScoreTableCell, _super);
    function ScoreTableCell() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ScoreTableCell.prototype.get_display = function () {
        return (this.data ?
            React.createElement("span", null,
                this.data > 80 ? React.createElement("i", { className: "text-success-bright fas fa-fw fa-check" })
                    : React.createElement("i", { className: "text-danger fas fa-fw fa-times" }),
                ' ',
                this.data,
                '%')
            : React.createElement("span", null, gettext("Awaiting...")));
    };
    return ScoreTableCell;
}(TableCell));
exports.ScoreTableCell = ScoreTableCell;
var TableCellDataFile = (function (_super) {
    __extends(TableCellDataFile, _super);
    function TableCellDataFile(name, url) {
        var _this = _super.call(this) || this;
        _this.name = name;
        _this.url = url;
        _this.file_name = name;
        _this.content = null;
        return _this;
    }
    return TableCellDataFile;
}(TableCellData));
exports.TableCellDataFile = TableCellDataFile;
var FileContentCell = (function (_super) {
    __extends(FileContentCell, _super);
    function FileContentCell() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FileContentCell.prototype.get_display = function () {
        return (React.createElement("span", null,
            React.createElement("a", { href: this.data.url, target: '_blank' }, this.data.name)));
    };
    return FileContentCell;
}(TableCell));
exports.FileContentCell = FileContentCell;
var HyperLinkTableCell = (function (_super) {
    __extends(HyperLinkTableCell, _super);
    function HyperLinkTableCell() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HyperLinkTableCell.prototype.get_display = function () {
        return (React.createElement("span", null,
            React.createElement("a", { href: this.data },
                React.createElement("i", { className: 'fas fa-fw fa-external-link-alt' }))));
    };
    return HyperLinkTableCell;
}(TableCell));
exports.HyperLinkTableCell = HyperLinkTableCell;
var NumberTableCell = (function (_super) {
    __extends(NumberTableCell, _super);
    function NumberTableCell() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return NumberTableCell;
}(TableCell));
exports.NumberTableCell = NumberTableCell;
var CheckboxesTableCell = (function (_super) {
    __extends(CheckboxesTableCell, _super);
    function CheckboxesTableCell() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return CheckboxesTableCell;
}(TableCell));
exports.CheckboxesTableCell = CheckboxesTableCell;
var SelectionsCell = (function (_super) {
    __extends(SelectionsCell, _super);
    function SelectionsCell() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return SelectionsCell;
}(TableCell));
exports.SelectionsCell = SelectionsCell;
var MeasurementTableCell = (function (_super) {
    __extends(MeasurementTableCell, _super);
    function MeasurementTableCell() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return MeasurementTableCell;
}(TableCell));
exports.MeasurementTableCell = MeasurementTableCell;
var OwnerTableCell = (function (_super) {
    __extends(OwnerTableCell, _super);
    function OwnerTableCell() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return OwnerTableCell;
}(TableCell));
exports.OwnerTableCell = OwnerTableCell;
var EvaluationTableCell = (function (_super) {
    __extends(EvaluationTableCell, _super);
    function EvaluationTableCell() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EvaluationTableCell.prototype.get_display = function () {
        var risk_level = {
            critical: this.data.critical,
            level: this.data.color,
            opportunity: this.data.is_opportunity
        };
        return (React.createElement(riskvalue_1.default, { risklevel: risk_level, value: this.data.value, show_explicit_value: this.data.show_explicit_value }));
    };
    return EvaluationTableCell;
}(TableCell));
exports.EvaluationTableCell = EvaluationTableCell;
var BimLocationsTableCell = (function (_super) {
    __extends(BimLocationsTableCell, _super);
    function BimLocationsTableCell() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BimLocationsTableCell.prototype.get_display = function () {
        return (React.createElement(buttons_1.ActionButton, { className: "BIMLocationCellButton", type: "button" },
            gettext("Map"), "(".concat(this.data, ")")));
    };
    return BimLocationsTableCell;
}(TableCell));
exports.BimLocationsTableCell = BimLocationsTableCell;
var LinksTableCell = (function (_super) {
    __extends(LinksTableCell, _super);
    function LinksTableCell() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.clickLinkHandler = function (link) { return function (event) {
            event.stopPropagation();
            if (link.onClick) {
                (0, utils_1.preventDefault)(event);
                link.onClick(link.id);
            }
        }; };
        return _this;
    }
    LinksTableCell.prototype.get_display = function () {
        var _this = this;
        return (React.createElement(React.Fragment, null, this.data.links.map(function (link, index) { return (React.createElement(React.Fragment, null,
            React.createElement("a", { href: link.url, onClick: _this.clickLinkHandler(link) }, _this.data.show_titles ?
                "#".concat(link.number, ": ").concat(link.title) :
                "".concat(link.number)),
            index === _this.data.links.length - 1 ? null : ', ')); })));
    };
    return LinksTableCell;
}(TableCell));
exports.LinksTableCell = LinksTableCell;
var WorstRiskTableCell = (function (_super) {
    __extends(WorstRiskTableCell, _super);
    function WorstRiskTableCell() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WorstRiskTableCell.prototype.get_display = function () {
        var risk_level = {
            critical: this.data.critical,
            level: this.data.worst_risk_color,
            opportunity: false
        };
        return (React.createElement(riskvalue_1.default, { risklevel: risk_level, value: this.data.worst_risk_value, show_explicit_value: this.data.show_explicit_value }));
    };
    return WorstRiskTableCell;
}(TableCell));
exports.WorstRiskTableCell = WorstRiskTableCell;
var BestRiskTableCell = (function (_super) {
    __extends(BestRiskTableCell, _super);
    function BestRiskTableCell() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BestRiskTableCell.prototype.get_display = function () {
        var risk_level = {
            critical: this.data.critical,
            level: this.data.best_risk_color,
            opportunity: true
        };
        return (React.createElement(riskvalue_1.default, { risklevel: risk_level, value: this.data.best_risk_value, show_explicit_value: this.data.show_explicit_value }));
    };
    return BestRiskTableCell;
}(TableCell));
exports.BestRiskTableCell = BestRiskTableCell;
var DeadlineTableCell = (function (_super) {
    __extends(DeadlineTableCell, _super);
    function DeadlineTableCell() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DeadlineTableCell.prototype.get_display = function () {
        return (React.createElement(deadline_1.default, { date: this.display, urgency: this.data.urgency }));
    };
    return DeadlineTableCell;
}(TableCell));
exports.DeadlineTableCell = DeadlineTableCell;
var CausalityTableCell = (function (_super) {
    __extends(CausalityTableCell, _super);
    function CausalityTableCell() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CausalityTableCell.prototype.get_display = function () {
        return (React.createElement(lists_1.ListObjects, { editable: false, deletable: false, detachable: false, objects: this.data.causalities, getListItemContent: function (c) {
                return React.createElement(causality_1.CausalityDisplay, { causality: c, maxTextLength: 100 });
            }, groupByFunc: this.data.show_statuses.length > 1 ?
                function (c) { return c.status_display; } : null, sortObjects: function (a, b) { return a.status - b.status || a.number - b.number; } }));
    };
    return CausalityTableCell;
}(TableCell));
exports.CausalityTableCell = CausalityTableCell;
var ReferenceTableCell = (function (_super) {
    __extends(ReferenceTableCell, _super);
    function ReferenceTableCell() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ReferenceTableCell.prototype.get_display = function () {
        return (React.createElement(referenceList_1.ReferenceList, { referredObject: this.data.originType, references: this.data.references, editable: false, deletable: false }));
    };
    return ReferenceTableCell;
}(TableCell));
exports.ReferenceTableCell = ReferenceTableCell;
